// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconEyeOff = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M15.5 3l-1.116 2.232A12.4 12.4 0 0012 5C7.5 5 3 7.5 2 11.5v1c.685 2.74 3.012 4.776 5.857 5.787L6.5 21h2.25l9-18zM12 7q.742 0 1.45.1l-.97 1.938a3 3 0 00-2.561 5.123l-1.163 2.327C6.385 15.709 4.572 14.116 4 12.231v-.462C4.813 9.09 8.133 7 12 7"
    />,
    <path d="M18.169 6.662l-.898 1.796c1.35.85 2.335 2.012 2.729 3.311v.462c-.74 2.439-3.558 4.39-6.975 4.72L12 19c4.5 0 9-2.5 10-6.5v-1c-.513-2.053-1.948-3.71-3.831-4.838" />
  );
export default SvgIconEyeOff;
